export const gcpTpuPaths = {
  list: (connectionId, locations = '') => {
    const query = String(locations || '').trim();
    return query
      ? `/compute/cloud-account-connections/${connectionId}/gcp/tpus?locations=${encodeURIComponent(query)}`
      : `/compute/cloud-account-connections/${connectionId}/gcp/tpus`;
  },
  catalog: (connectionId, locations = '') => {
    const query = String(locations || '').trim();
    return query
      ? `/compute/cloud-account-connections/${connectionId}/gcp/tpus/catalog?locations=${encodeURIComponent(query)}`
      : `/compute/cloud-account-connections/${connectionId}/gcp/tpus/catalog`;
  },
  detail: (connectionId, location, name) =>
    `/compute/cloud-account-connections/${connectionId}/gcp/tpus/${encodeURIComponent(location)}/${encodeURIComponent(name)}`,
  create: (connectionId) => `/compute/cloud-account-connections/${connectionId}/gcp/tpus`,
  start: (connectionId, location, name) =>
    `/compute/cloud-account-connections/${connectionId}/gcp/tpus/${encodeURIComponent(location)}/${encodeURIComponent(name)}/start`,
  stop: (connectionId, location, name) =>
    `/compute/cloud-account-connections/${connectionId}/gcp/tpus/${encodeURIComponent(location)}/${encodeURIComponent(name)}/stop`,
  remove: (connectionId, location, name) =>
    `/compute/cloud-account-connections/${connectionId}/gcp/tpus/${encodeURIComponent(location)}/${encodeURIComponent(name)}`,
};
